export default __webpack_public_path__ + "static/media/voorbeeld-binnenhof-hoog.e65f9eff.jpg";